import { createBrowserHistory, History } from 'history';
// global history object. Controls and reads the current URL.
// This needs to be in its own file to solve circular import issues.
export const history: History = createBrowserHistory();
